import React, {useState} from 'react';
import {View} from 'react-native';
import {Divider} from 'react-native-paper';

import sy from '~/styles';
import {Text, Pressable, Link} from '~/components/controls';
import ExpandLessIcon from '~/images/md-icons/expand_less/materialicons/24px.svg';
import ExpandMoreIcon from '~/images/md-icons/expand_more/materialicons/24px.svg';
import PropTypes from 'prop-types';

import {EditDialog} from './EditDialog';
export {EditDialog};

export const Row = ({
  disabled = false,
  title,
  style,
  linkStyle,
  contentStyle,
  children,
  onEditClicked,
}) => {
  const contents = React.Children.map(children, (child) =>
    child?.type === EditDialog ? null : child,
  );

  const dialog = React.Children.toArray(children).find(
    (child) => child?.type === EditDialog,
  );
  const hasDialog = Boolean(dialog);

  const [edit, setEdit] = useState(false);

  return (
    <View
      style={[
        sy['p-4'],
        sy['border-b'],
        sy['border-lightgray'],
        sy['flex-row'],
        sy['justify-between'],
        {minHeight: 56, marginBottom: -1},
        style,
      ]}>
      {title && <Text>{title}</Text>}
      {hasDialog === false && <View style={contentStyle}>{contents}</View>}
      {hasDialog && (
        <>
          <Link
            disabled={disabled}
            style={contentStyle}
            textStyle={linkStyle}
            onPress={async () => {
              if (onEditClicked) {
                await onEditClicked();
              }

              setEdit((prevState) => !prevState);
            }}>
            {contents}
          </Link>
          {React.cloneElement(dialog, {
            visible: edit,
            onClose: () => {
              dialog.props.onClose?.();
              setEdit(false);
            },
          })}
        </>
      )}
    </View>
  );
};
Row.propTypes = {
  disabled: PropTypes.any,
  title: PropTypes.any,
  style: PropTypes.any,
  linkStyle: PropTypes.any,
  contentStyle: PropTypes.any,
  children: PropTypes.any,
  onEditClicked: PropTypes.any,
};

const Grouping = ({
  icon,
  header,
  children,
  style,
  pressableStyle,
  onExpand,
  initial = {expand: false},
  options = {topMost: false, switchChevrons: false},
}) => {
  const [expand, setExpand] = useState(initial.expand);

  const hasChildren = React.Children.toArray(children).length > 0;
  const showTopDivider = options.topMost !== true;

  const renderChevron = () => {
    if (!hasChildren) {
      return null;
    }

    if (options.switchChevrons === true) {
      return expand ? <ExpandMoreIcon /> : <ExpandLessIcon />;
    }

    return expand ? <ExpandLessIcon /> : <ExpandMoreIcon />;
  };

  return (
    <View>
      {showTopDivider && <Divider style={sy['bg-gray88']} />}
      <View style={[sy['bg-white'], style]}>
        <Pressable
          style={[
            sy['flex-row'],
            sy['items-center'],
            sy['justify-between'],
            sy['p-4'],
            sy['gap-4'],
            pressableStyle,
          ]}
          disabled={!hasChildren}
          onPress={() => {
            const value = !expand;
            setExpand(value);
            if (onExpand) {
              onExpand(value);
            }
          }}>
          <View
            style={[
              sy['flex-row'],
              sy['flex-1'],
              sy['items-center'],
              sy['gap-8'],
            ]}>
            {icon && <View>{icon}</View>}
            <Text style={[sy.mediumPlus, sy.truncate]}>{header}</Text>
          </View>
          {renderChevron()}
        </Pressable>
        {expand && <Divider style={sy['bg-gray88']} />}
        {expand && children}
      </View>
    </View>
  );
};
Grouping.propTypes = {
  icon: PropTypes.any,
  header: PropTypes.any,
  children: PropTypes.any,
  style: PropTypes.any,
  pressableStyle: PropTypes.any,
  onExpand: PropTypes.any,
  initial: PropTypes.any,
  options: PropTypes.any,
};

export default Grouping;
